/* Element.prototype.closest — Chrome 20 / old WebView (video.js needs this) */
(function () {
  if (typeof Element === "undefined") {
    return;
  }

  if (Element.prototype.closest) {
    return;
  }

  function elementMatches(el: Element, selector: string): boolean {
    var node = el as Element & {
      matches?: (sel: string) => boolean;
      webkitMatchesSelector?: (sel: string) => boolean;
      msMatchesSelector?: (sel: string) => boolean;
    };

    if (node.matches) {
      return node.matches(selector);
    }
    if (node.webkitMatchesSelector) {
      return node.webkitMatchesSelector(selector);
    }
    if (node.msMatchesSelector) {
      return node.msMatchesSelector(selector);
    }
    return false;
  }

  Element.prototype.closest = function (selector: string): Element | null {
    var el: Element | null = this;

    if (!document.documentElement || !document.documentElement.contains(el)) {
      return null;
    }

    do {
      if (elementMatches(el, selector)) {
        return el;
      }
      el = el.parentElement;
    } while (el !== null);

    return null;
  };
})();
